import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'patients',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'patients-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                   
                    {                           
                        transKey: 'breadcrumbs.patients-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "patients-index" */ '@/modules/patients/views/Index.vue')
        },
        {
            path: 'create',
            name: 'patients-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'patients-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.patients-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.patients-create',
                        isActive: true,
                    }
                    
                ]
            },
            component: () => import(/* webpackChunkName: "patients-create" */ '@/modules/patients/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'patients-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'patients-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.previous',
                        isActive: false,
                        isRedirect: true
                    },
                    {                           
                        transKey: 'breadcrumbs.patients-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "patients-edit" */ '@/modules/patients/views/Edit.vue')
        },
        {
            path: 'assignments-history/:userId/:patientId',
            name: 'assignments-history',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'patients-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.patients-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.patients-edit',
                        isActive: false,
                        isRedirect: true
                    },
                    {                           
                        transKey: 'breadcrumbs.patients-assignments-history',
                        isActive: true,
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "patients-create" */ '@/modules/patients/views/AssigmentsHistory.vue')
        },
    ]
}